export const baseURL = "https://appadmin.zoralive.com";
// export const baseURL = "http://localhost:5068";
